import { z } from "zod";
import { passwordSchema } from "./shared";

export const userSchema = z.object({
  firstName: z.string().min(2, "First name is required").max(50),
  lastName: z.string().min(2, "Last name is required").max(50),
  password: passwordSchema.optional(),
});
export type UserFormData = z.infer<typeof userSchema>;
